import {GET_APPLICATION_FILE} from "../../../enums/Request/request.types";

export const getApplicationFileAction = (blobLink) => {
    return {
        type: GET_APPLICATION_FILE,
        payload: blobLink,
    };
};
